export const EXTERNAL_PROPERTIES_MAX_ARTICLES = 51;
